import clsx from 'clsx'
import styled from 'styled-components'

import type { CarouselProps } from './types'

export const CarouselContent = styled.div`
  overflow: auto;
  margin-right: -0.5rem;
  margin-left: -0.5rem;

  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-color: transparent transparent;

  ::-webkit-scrollbar {
    display: none;
  }

  ::-moz-scrollbar {
    display: none;
  }
`

const Carousel = ({ children, className }: CarouselProps) => {
  const gridCarouselMobileClass = clsx(
    '_d-flex _w-full _position-relative _justify-content-center',
    className
  )

  return (
    <>
      <div className={gridCarouselMobileClass} data-test='base-carousel'>
        <CarouselContent className='_d-flex _vw-full _position-relative _align-items-start'>
          {children}
        </CarouselContent>
      </div>
    </>
  )
}

export default Carousel
